export default class CreateNewCart extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.events();

    }

    events() {
        $("#init_new_cart").on('click',(e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            let a = $("#init_new_cart");

            let qte = a.data('qte');
            let product_id = a.data('product_id');

            window.HegydCore.initRemoteModal(
                '#modal',
                a.prop('href'),
                function() {
                    $('.qte').val(qte);
                    $('.product_id').val(product_id);
                },
                (data) => {
                    if(data.hasOwnProperty('reload')){
                        location.reload();
                    } else {
                        if(data.hasOwnProperty('errors')){
                            if(data.errors.length > 0){
                                toastr.error(data.errors);
                            } else{
                                toastr.success(data.message);
                            }
                        } else{
                            toastr.success(data.message);
                        }
                    }
                },
                () => {
                     toastr.error('Une erreur s\'est produite');
                }
            );
        });
    }
}
